import { atlas } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

type DeleteQuestionGroupParams = {
  id: Uuid;
};

export const deleteQuestionGroup = async ({
  id,
}: DeleteQuestionGroupParams) => {
  return await atlas.remove(`question-groups/${id}`);
};
